/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, BigNumberish, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../../common';
import type { MerkleOrderbook, MerkleOrderbookInterface } from '../../MerkleOrderBook.sol/MerkleOrderbook';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_policyToken',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_cashToken',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_cashWallet',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_factoryIndex',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'InvalidAmount',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidCancelOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidPolicyTokenAmount',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'maker',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isCollateralOrder',
        type: 'bool',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'orderAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'orderPrice',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'CancelBuyOrder',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'maker',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'orderAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'orderPrice',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'CancelSellOrder',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'maker',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isCollateralOrder',
        type: 'bool',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'orderAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'orderPrice',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'NewBuyOrder',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'maker',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'orderAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'orderPrice',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'NewSellOrder',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'maker',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'takeAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'takePrice',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'orderTaken',
        type: 'uint256',
      },
    ],
    name: 'TakeBuyOrder',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'maker',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'takeAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'takePrice',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'orderTaken',
        type: 'uint256',
      },
    ],
    name: 'TakeSellOrder',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'Fills',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'OrdersRoot',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'buyHead',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'buyNext',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'cancelOrder',
            type: 'tuple',
          },
          {
            internalType: 'bytes',
            name: 'cancelOrderSignature',
            type: 'bytes',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'nextOrder',
            type: 'tuple',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'prevOrder',
            type: 'tuple',
          },
        ],
        internalType: 'struct CancelOrderReq',
        name: 'req',
        type: 'tuple',
      },
    ],
    name: 'cancelMakeOrder',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'cashToken',
    outputs: [
      {
        internalType: 'contract ERC20',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'cashWallet',
    outputs: [
      {
        internalType: 'contract CashWallet',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'orderHash',
        type: 'bytes32',
      },
    ],
    name: 'digestCancelOrder',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'factoryIndex',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'newOrder',
            type: 'tuple',
          },
          {
            internalType: 'bytes',
            name: 'newOrderSignature',
            type: 'bytes',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'maker',
                type: 'address',
              },
              {
                internalType: 'bool',
                name: 'isSell',
                type: 'bool',
              },
              {
                internalType: 'bool',
                name: 'isCollateralOrder',
                type: 'bool',
              },
              {
                internalType: 'uint256',
                name: 'orderAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'orderPrice',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
              },
            ],
            internalType: 'struct Order',
            name: 'headOrder',
            type: 'tuple',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'prevOrder',
            type: 'tuple',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'injectOrder',
            type: 'tuple',
          },
        ],
        internalType: 'struct MakeOrderReq',
        name: 'req',
        type: 'tuple',
      },
    ],
    name: 'makeOrder',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'policyToken',
    outputs: [
      {
        internalType: 'contract PolicyToken',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'policyTokenBalance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'sellHead',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'sellNext',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        components: [
          {
            components: [
              {
                internalType: 'address',
                name: 'maker',
                type: 'address',
              },
              {
                internalType: 'bool',
                name: 'isSell',
                type: 'bool',
              },
              {
                internalType: 'bool',
                name: 'isCollateralOrder',
                type: 'bool',
              },
              {
                internalType: 'uint256',
                name: 'orderAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'orderPrice',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
              },
            ],
            internalType: 'struct Order',
            name: 'order',
            type: 'tuple',
          },
          {
            internalType: 'bytes32[]',
            name: 'proofs',
            type: 'bytes32[]',
          },
          {
            internalType: 'uint8',
            name: 'bits',
            type: 'uint8',
          },
        ],
        internalType: 'struct OrderWithProofs',
        name: 'headOrder',
        type: 'tuple',
      },
      {
        components: [
          {
            components: [
              {
                internalType: 'address',
                name: 'maker',
                type: 'address',
              },
              {
                internalType: 'bool',
                name: 'isSell',
                type: 'bool',
              },
              {
                internalType: 'bool',
                name: 'isCollateralOrder',
                type: 'bool',
              },
              {
                internalType: 'uint256',
                name: 'orderAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'orderPrice',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
              },
            ],
            internalType: 'struct Order',
            name: 'order',
            type: 'tuple',
          },
          {
            internalType: 'bytes32[]',
            name: 'proofs',
            type: 'bytes32[]',
          },
          {
            internalType: 'uint8',
            name: 'bits',
            type: 'uint8',
          },
        ],
        internalType: 'struct OrderWithProofs',
        name: 'headsNextOrder',
        type: 'tuple',
      },
    ],
    name: 'takeBuyHead',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        components: [
          {
            components: [
              {
                internalType: 'address',
                name: 'maker',
                type: 'address',
              },
              {
                internalType: 'bool',
                name: 'isSell',
                type: 'bool',
              },
              {
                internalType: 'bool',
                name: 'isCollateralOrder',
                type: 'bool',
              },
              {
                internalType: 'uint256',
                name: 'orderAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'orderPrice',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
              },
            ],
            internalType: 'struct Order',
            name: 'order',
            type: 'tuple',
          },
          {
            internalType: 'bytes32[]',
            name: 'proofs',
            type: 'bytes32[]',
          },
          {
            internalType: 'uint8',
            name: 'bits',
            type: 'uint8',
          },
        ],
        internalType: 'struct OrderWithProofs',
        name: 'headOrder',
        type: 'tuple',
      },
      {
        components: [
          {
            components: [
              {
                internalType: 'address',
                name: 'maker',
                type: 'address',
              },
              {
                internalType: 'bool',
                name: 'isSell',
                type: 'bool',
              },
              {
                internalType: 'bool',
                name: 'isCollateralOrder',
                type: 'bool',
              },
              {
                internalType: 'uint256',
                name: 'orderAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'orderPrice',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
              },
            ],
            internalType: 'struct Order',
            name: 'order',
            type: 'tuple',
          },
          {
            internalType: 'bytes32[]',
            name: 'proofs',
            type: 'bytes32[]',
          },
          {
            internalType: 'uint8',
            name: 'bits',
            type: 'uint8',
          },
        ],
        internalType: 'struct OrderWithProofs',
        name: 'headsNextOrder',
        type: 'tuple',
      },
    ],
    name: 'takeSellHead',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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__$8e3621e24b04d9c377ed8107e8a45be3dc$__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__$8e3621e24b04d9c377ed8107e8a45be3dc$__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__$c07359d48572056cb4c07719406c829e6c$__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__$c07359d48572056cb4c07719406c829e6c$__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__$7bfc45cf45f43ae9f3259c6c8c6505aae3$__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__$7bfc45cf45f43ae9f3259c6c8c6505aae3$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';

type MerkleOrderbookConstructorParams =
  | [linkLibraryAddresses: MerkleOrderbookLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: MerkleOrderbookConstructorParams): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === 'string' ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    '_isInterface' in xs[0]
  );
};

export class MerkleOrderbook__factory extends ContractFactory {
  constructor(...args: MerkleOrderbookConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, MerkleOrderbook__factory.linkBytecode(linkLibraryAddresses), signer);
    }
    this.contractName = 'MerkleOrderbook';
  }

  static linkBytecode(linkLibraryAddresses: MerkleOrderbookLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$8e3621e24b04d9c377ed8107e8a45be3dc\\$__', 'g'),
      linkLibraryAddresses['contracts/MerkleOrderBookTemplate.sol:MakeOrderLib'].replace(/^0x/, '').toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$c07359d48572056cb4c07719406c829e6c\\$__', 'g'),
      linkLibraryAddresses['contracts/MerkleOrderBookTemplate.sol:TakeOrderLib'].replace(/^0x/, '').toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$7bfc45cf45f43ae9f3259c6c8c6505aae3\\$__', 'g'),
      linkLibraryAddresses['contracts/MerkleOrderBookTemplate.sol:CancelOrderLib'].replace(/^0x/, '').toLowerCase()
    );

    return linkedBytecode;
  }

  override deploy(
    _policyToken: PromiseOrValue<string>,
    _cashToken: PromiseOrValue<string>,
    _cashWallet: PromiseOrValue<string>,
    _factoryIndex: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<MerkleOrderbook> {
    return super.deploy(
      _policyToken,
      _cashToken,
      _cashWallet,
      _factoryIndex,
      overrides || {}
    ) as Promise<MerkleOrderbook>;
  }
  override getDeployTransaction(
    _policyToken: PromiseOrValue<string>,
    _cashToken: PromiseOrValue<string>,
    _cashWallet: PromiseOrValue<string>,
    _factoryIndex: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_policyToken, _cashToken, _cashWallet, _factoryIndex, overrides || {});
  }
  override attach(address: string): MerkleOrderbook {
    return super.attach(address) as MerkleOrderbook;
  }
  override connect(signer: Signer): MerkleOrderbook__factory {
    return super.connect(signer) as MerkleOrderbook__factory;
  }
  static readonly contractName: 'MerkleOrderbook';

  public readonly contractName: 'MerkleOrderbook';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MerkleOrderbookInterface {
    return new utils.Interface(_abi) as MerkleOrderbookInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): MerkleOrderbook {
    return new Contract(address, _abi, signerOrProvider) as MerkleOrderbook;
  }
}

export interface MerkleOrderbookLibraryAddresses {
  ['contracts/MerkleOrderBookTemplate.sol:MakeOrderLib']: string;
  ['contracts/MerkleOrderBookTemplate.sol:TakeOrderLib']: string;
  ['contracts/MerkleOrderBookTemplate.sol:CancelOrderLib']: string;
}
